import request from "@/http/request"
import {
    updateCourse,
    addCourse,
    batchPrintCertificate,
    deleteCourse,
    queryCourse,
    queryCourseList,
    updateCourseState,
    queryAllCourse,
    getPlanCourse,
    getSpecialInputting,
    updatePlanCourse,
    importCourse,
    getPlanCourseExempt,
    getPlanCourseExemptScope,
    getExemptReasonList,
    uploadExemptFile,
    getStudentCourseExemptList,
    exportStudentCourseExemptFile,
    exportCourseList
} from '@/http/api'

export const exportCourseListAPI = (data) => {
    return request({
        url: exportCourseList,
        data
    })
}

export const exportStudentCourseExemptFileAPI = (data) => {
    return request({
        url: exportStudentCourseExemptFile,
        data
    })
}

export const getStudentCourseExemptListAPI = (data) => {
    return request({
        url: getStudentCourseExemptList,
        data
    })
}

export const uploadExemptFileAPI = (data) => {
    return request({
        url: uploadExemptFile,
        data,
        isUpload: true
    })
}

export const importCourseAPI = (data) => {
    return request({
        url: importCourse,
        data,
        isUpload: true
    })
}

export const getExemptReasonListAPI = (data) => {
    return request({
        url: getExemptReasonList,
        data
    })
}

export const getPlanCourseExemptScopeAPI = (data) => {
    return request({
        url: getPlanCourseExemptScope,
        data
    })
}

export const getPlanCourseExemptAPI = (data) => {
    return request({
        url: getPlanCourseExempt,
        data
    })
}

export const updatePlanCourseAPI = (data) => {
    return request({
        url: updatePlanCourse,
        data
    })
}

export const getSpecialInputtingAPI = (data) => {
    return request({
        url: getSpecialInputting,
        data
    })
}

export const batchPrintCertificateFn = (data) => {
    return request({
        url: batchPrintCertificate,
        data
    })
}
export const addCourseFn = (data) => {
    return request({
        url: addCourse,
        data
    })
}
export const deleteCourseFn = (data) => {
    return request({
        url: deleteCourse,
        data
    })
}
export const updateCourseStateFn = (data) => {
    return request({
        url: updateCourseState,
        data
    })
}
export const updateCourseFn = (data) => {
    return request({
        url: updateCourse,
        data
    })
}
export const getSingleCourse = (data) => {
    return request({
        url: queryCourse,
        data
    })
}
export const getAllCourse = (data) => {
    return request({
        url: queryCourseList,
        data
    })
}
export const getSelectCourse = (data = {state: 1}) => {
    return request({
        url: queryAllCourse,
        data
    })
}
export const getPlanCourseFn = (data) => {
    return request({
        url: getPlanCourse,
        data
    })
} 